import React, { createContext, useCallback, useMemo, useState } from 'react'
import { Toast } from 'react-bootstrap'
import { StyledToast } from 'components/Share/Toast.styled'

export interface IToastContext {
  setToastData: (isShow: boolean, message: string, type: string, autohide?: boolean) => void
  setShowToast: (isShow: boolean) => void
}

export const ToastContext = createContext<IToastContext>({} as IToastContext)

export const ToastContextProvider = ({ children }: React.PropsWithChildren<{}>) => {
  const [showToast, setShowToast] = useState<boolean>(false)
  const [toastMessage, setToastMessage] = useState<string>('')
  const [toastType, setToastType] = useState<string>('')
  const [autoHide, setAutoHide] = useState<boolean>(true)

  const setToastData = useCallback(
    (isShow: boolean, message: string, type: string, autohide: boolean = true) => {
      setShowToast(isShow)
      setToastMessage(message)
      setToastType(type)
      setAutoHide(autohide)
    },
    // useState setters are stable — empty deps is intentional
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const contextValue = useMemo(
    () => ({ setToastData, setShowToast }),
    // setShowToast (from useState) and setToastData (useCallback with []) are both stable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return (
    <ToastContext.Provider value={contextValue}>
      <StyledToast
        onClose={() => setShowToast(false)}
        type={toastType}
        show={showToast}
        className="toast-contain"
        delay={8000}
        autohide={autoHide}
      >
        <Toast.Body className="toast-body">{toastMessage}</Toast.Body>
        <button onClick={() => setShowToast(false)}>x</button>
      </StyledToast>
      {children}
    </ToastContext.Provider>
  )
}
